export default {
  entries: []
}
